import { useEffect, useState } from "react";

import { ProgressBar } from "#shared/view/components/ProgressBar";

export const AutoLoader = () => {
  const [embeddingProgress, setEmbeddingProgress] = useState(0);

  useEffect(() => {
    setInterval(() => {
      setEmbeddingProgress((tmp) => tmp + 0.5);
    }, 1000);
  }, []);

  return <ProgressBar value={(embeddingProgress * 100) / 30} animated style={{ width: 300 }} />;
};
